import React, { FunctionComponent } from 'react';
// import Table from 'react-bootstrap/Table'
import { Link } from 'react-router-dom';
import './Menu.scss';
import IconArrowRight from '../../assets/icons/arrow-right-icon.svg';

interface SubMenuItemProps {
  active?: boolean;
  label?: string;
  link: string;
}

type ISubMenuItem = FunctionComponent<SubMenuItemProps>;

const SubMenuItem: ISubMenuItem = ({ active, link, label }) => {
  return (
    <div>
      <span className={'menu_subitem'}>
        <IconArrowRight className={'sub-menu-item-icon'} />
      </span>{' '}
      <span className={active ? 'menu_item_active' : ''}>
        <Link to={link}>{label}</Link>
      </span>
    </div>
  );
};

interface MenuItemProps {
  icon?: React.ReactNode;
  active?: boolean;
  subItemActive?: boolean;
  label?: string;
  link: string;
}

type IMenuItem = FunctionComponent<MenuItemProps>;

const MenuItem: IMenuItem = ({
  icon,
  active,
  link,
  label,
  subItemActive,
  children
}) => {
  return (
    <div className={'menu_row'}>
      <div className={'menu_icon'}>{icon}</div>
      <div className={'menu_item'}>
        <div>
          <span className={active ? 'menu_item_active' : ''}>
            <Link to={link}>{label}</Link>
          </span>
        </div>
        {subItemActive && children}
      </div>
    </div>
  );
};

interface MenuProps {
  children: React.ReactElement<IMenuItem> | React.ReactElement<IMenuItem>[];
}
const Menu = ({ children }: MenuProps) => {
  return <div className={'menu_container'}>{children}</div>;
};

export { Menu, MenuItem, SubMenuItem };
